import { render, staticRenderFns } from "./BtnExcluirMovimentacao.vue?vue&type=template&id=401deb2c&"
import script from "./BtnExcluirMovimentacao.vue?vue&type=script&lang=js&"
export * from "./BtnExcluirMovimentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports